export type Employee = {
    _id: string;
    srNo: number;
    employeeId: string;
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    department: string;
    jobProfile: string;
    employmentType: string;
    joiningDate: string;
    isOnboarded: boolean;
    hiringStatus: string;
    notes: any[];
    createdAt: string;
    address: string;
    gender: string;
    teamStatus: string;
    crmAccess: CRM_ACCESS;
};

export enum CRM_ACCESS {
    PENDING = "Pending",
    APPROVE = "Approved",
    REJECTED = "Rejected",
}
